module.exports = __webpack_public_path__ + "media/images/how-you-want-it-2091378ced3990d87fbbc62a47e56202.svg";